import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';
import { leaveKeys } from './useMijnVerlof';

/** Story 3.3: retry een mislukte Nmbrs-boeking. Invalideert zowel de goedkeuringslijst als de eigen-overzicht-cache (beide tonen de sync-chip). */
export function useRetrySync() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => verlofApi.retrySync(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
      queryClient.invalidateQueries({ queryKey: leaveKeys.mine() });
    },
  });
}
